import Vue from 'vue'
// import Router from 'vue-router'
import Login from './views/Login.vue'
import Home from './views/Home.vue'
import Intro from './views/Intro.vue'
import IntroVideo from './views/IntroVideo.vue'
import AnitaHammer from './views/AnitaHammer.vue'
import Rental from './views/Rental.vue'
import JohnDeerling from './views/JohnDeerling.vue'
import Bolo from './views/Bolo.vue'
import TruckSighting from './views/TruckSighting.vue'
import Roadblock from './views/Roadblock.vue'
import CruellaDeWalt from './views/CruellaDeWalt.vue'
import Blitz from './views/Blitz.vue'
import BlitzVideo from './views/BlitzVideo.vue'
import WoodySteale from './views/WoodySteale.vue'
import CargoVan from './views/CargoVan.vue'
import GpsSurveillance from './views/GpsSurveillance.vue'
import PawnShop from './views/PawnShop.vue'
import OrangePickup from './views/OrangePickup.vue'
import RobOToole from './views/RobOToole.vue'
import CaseUpdate from './views/CaseUpdate.vue'
import PawnShopOwner from './views/PawnShopOwner.vue'
import TriviaAnswers from './components/TriviaAnswers.vue'
import Trivia1 from './views/Trivia1.vue'
import Trivia2 from './views/Trivia2.vue'
import Trivia3 from './views/Trivia3.vue'
import Trivia4 from './views/Trivia4.vue'
import Trivia5 from './views/Trivia5.vue'
import Trivia6 from './views/Trivia6.vue'
import Trivia7 from './views/Trivia7.vue'
import Trivia8 from './views/Trivia8.vue'
import Trivia9 from './views/Trivia9.vue'
import Trivia10 from './views/Trivia10.vue'
import Trivia11 from './views/Trivia11.vue'
import Trivia12 from './views/Trivia12.vue'
import Trivia13 from './views/Trivia13.vue'
import Trivia14 from './views/Trivia14.vue'
import Trivia15 from './views/Trivia15.vue'
import Trivia16 from './views/Trivia16.vue'
import Trivia17 from './views/Trivia17.vue'
import Trivia18 from './views/Trivia18.vue'
import Trivia19 from './views/Trivia19.vue'
import Yarnboard2 from './views/Yarnboard2.vue'
import Yarnboard3 from './views/Yarnboard3.vue'
import Yarnboard4 from './views/Yarnboard4.vue'
import Review from './views/Review.vue'
import ConclusionVideo from './views/ConclusionVideo.vue'
import Takeaway from './views/Takeaway.vue'
import ClearData from './views/ClearData.vue'
import VueRouter from 'vue-router';
import store from './store.js'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'login',
            component: Login
        }, {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/intro',
            name: 'intro',
            component: Intro
        },
        {
            path: '/intro-video',
            name: 'intro-video',
            component: IntroVideo
        },
        {
            path: '/anita-hammer',
            name: 'anita-hammer',
            component: AnitaHammer
        },
        {
            path: '/rental',
            name: 'rental',
            component: Rental
        },
        {
            path: '/john-deerling',
            name: 'john-deerling',
            component: JohnDeerling
        },
        {
            path: '/bolo',
            name: 'bolo',
            component: Bolo
        },
        {
            path: '/truck-sighting',
            name: 'truck-sighting',
            component: TruckSighting
        },
        {
            path: '/roadblock',
            name: 'roadblock',
            component: Roadblock
        },
        {
            path: '/cruella-dewalt',
            name: 'cruella-dewalt',
            component: CruellaDeWalt
        },
        {
            path: '/blitz',
            name: 'blitz',
            component: Blitz
        },
        {
            path: '/blitz-video',
            name: 'blitz-video',
            component: BlitzVideo
        },
        {
            path: '/woody-steale',
            name: 'woody-steale',
            component: WoodySteale
        },
        {
            path: '/cargo-van',
            name: 'cargo-van',
            component: CargoVan
        },
        {
            path: '/gps-surveillance',
            name: 'gps-surveillance',
            component: GpsSurveillance
        },
        {
            path: '/pawn-shop',
            name: 'pawn-shop',
            component: PawnShop
        },
        {
            path: '/orange-pickup',
            name: 'orange-pickup',
            component: OrangePickup
        },
        {
            path: '/rob-otoole',
            name: 'rob-otoole',
            component: RobOToole
        },
        {
            path: '/case-update',
            name: 'case-update',
            component: CaseUpdate
        },
        {
            path: '/pawn-shop-owner',
            name: 'pawn-shop-owner',
            component: PawnShopOwner
        },
        {
            path: '/trivia-answers',
            name: 'trivia-answers',
            component: TriviaAnswers,
            props: true
        },
        {
            path: '/trivia-1',
            name: 'trivia1',
            component: Trivia1
        },
        {
            path: '/trivia-2',
            name: 'trivia2',
            component: Trivia2
        },
        {
            path: '/trivia-3',
            name: 'trivia3',
            component: Trivia3
        },
        {
            path: '/trivia-4',
            name: 'trivia4',
            component: Trivia4
        },
        {
            path: '/trivia-5',
            name: 'trivia5',
            component: Trivia5
        },
        {
            path: '/trivia-6',
            name: 'trivia6',
            component: Trivia6
        },
        {
            path: '/trivia-7',
            name: 'trivia7',
            component: Trivia7
        },
        {
            path: '/trivia-8',
            name: 'trivia8',
            component: Trivia8
        },
        {
            path: '/trivia-9',
            name: 'trivia9',
            component: Trivia9
        },
        {
            path: '/trivia-10',
            name: 'trivia10',
            component: Trivia10
        },
        {
            path: '/trivia-11',
            name: 'trivia11',
            component: Trivia11
        },
        {
            path: '/trivia-12',
            name: 'trivia12',
            component: Trivia12
        },
        {
            path: '/trivia-13',
            name: 'trivia13',
            component: Trivia13
        },
        {
            path: '/trivia-14',
            name: 'trivia14',
            component: Trivia14
        },
        {
            path: '/trivia-15',
            name: 'trivia15',
            component: Trivia15
        },
        {
            path: '/trivia-16',
            name: 'trivia16',
            component: Trivia16
        },
        {
            path: '/trivia-17',
            name: 'trivia17',
            component: Trivia17
        },
        {
            path: '/trivia-18',
            name: 'trivia18',
            component: Trivia18
        },
        {
            path: '/trivia-19',
            name: 'trivia19',
            component: Trivia19
        },
        {
            path: '/yarnboard-2',
            name: 'yarnboard2',
            component: Yarnboard2
        },
        {
            path: '/yarnboard-3',
            name: 'yarnboard3',
            component: Yarnboard3
        },
        {
            path: '/yarnboard-4',
            name: 'yarnboard4',
            component: Yarnboard4
        },
        {
            path: '/conclusion-video',
            name: 'conclusion-video',
            component: ConclusionVideo
        },
        {
            path: '/review',
            name: 'review',
            component: Review
        },
        {
            path: '/takeaway',
            name: 'takeaway',
            component: Takeaway
        },
        {
            path: '/clear-data',
            name: 'clear-data',
            component: ClearData
        },
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name.includes('trivia') && !to.name.includes('trivia-answers')) {
        let triviaNo = to.name.replace('trivia', '')
        if (triviaNo < store.state.currentTrivia) {
            alert("You have already answered this trivia question")
            next(false)
        } else {
            next()
        }
    } else {
        next()
    }

    store.dispatch('setLoading', false)
})

router.afterEach(() => {
    store.dispatch('setLoading', true)
    window.setTimeout(() => {
        window.scrollTo(0, 1)
    }, 1000)
})

export default router